import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { History } from '../interfaces/history.interface';
import { DateTime } from 'luxon';
import { trackById } from '../../../../utils/track-by';
import icSettings from '@iconify/icons-ic/twotone-settings';
import icChevronRight from '@iconify/icons-ic/twotone-chevron-right';
import icNotificationsOff from '@iconify/icons-ic/twotone-notifications-off';
import icClearAll from '@iconify/icons-ic/twotone-clear-all';
import icShoppingBasket from '@iconify/icons-ic/twotone-shopping-basket';
import icAccountCircle from '@iconify/icons-ic/twotone-account-circle';
import icInsertChart from '@iconify/icons-ic/twotone-insert-chart';
import icCheckCircle from '@iconify/icons-ic/twotone-check-circle';
import icDescription from '@iconify/icons-ic/twotone-description';
import icFeedback from '@iconify/icons-ic/twotone-feedback';
import icVerifiedUser from '@iconify/icons-ic/twotone-verified-user';
import icFileCopy from '@iconify/icons-ic/twotone-file-copy';
import icHistory from '@iconify/icons-ic/twotone-history';
import { ToolbarService } from '../../../../../@vex/services/toolbar.service';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';

@Component({
  selector: 'vex-toolbar-history-dropdown',
  templateUrl: './toolbar-history-dropdown.component.html',
  styleUrls: ['./toolbar-history-dropdown.component.scss'],
})
export class ToolbarHistoryDropdownComponent implements OnInit {
  icHistory = icHistory;
  historyData: any = [];

  icSettings = icSettings;
  icChevronRight = icChevronRight;
  icClearAll = icClearAll;
  icNotificationsOff = icNotificationsOff;
  trackById = trackById;

  constructor(private _toolbarService: ToolbarService,
    private _popoverRef: PopoverRef) { }

    loader: boolean;

  ngOnInit() {
    this.getHistoryData();
  }

  getHistoryData() {
    this._toolbarService.getToolbarHistoryData().subscribe((data) => {
      this.historyData = data;
      this.loader = true;
    });
  }

  setLinkInfo(data) {
    if (data.RID) {
      localStorage.setItem('jid', data.JID);
      localStorage.setItem('rid', data.RID);
    } else {
      localStorage.setItem('jid', data.JID);
    }

    this._popoverRef.close();    
  }
}
